import { IRapportInfo } from '../../../../../Types/RapportInfoType';
// import { rapportInfos } from '../RapportInfo';

const OFRapportMeny: IRapportInfo[] = [];

export default OFRapportMeny;
